import React, { Fragment, useContext } from "react";
import { Outlet } from "react-router-dom";

import Taptop from "./TapTop";
import Header from "./Header";
import Sidebar from "./Sidebar";
import CustomizerContext from "../_helper/Customizer";
import Loader from "./Loader";

import storage from "../utils/storage";
import { NotificationsProvider } from "../Components/Application/Notification/notificationsStore";
import { ChatProvider } from "../Components/Application/Chat/chatStore";
import ChatLauncher from "../Components/Application/Chat/ChatLauncher";

const AppLayout = () => {
  const { layout, sidebarIconType, toggleIcon } = useContext(CustomizerContext);

  const layout1 = storage.theme.getSidebarLayout() || layout;
  const sideBarIcon =
    storage.theme.getSidebarIconType() || sidebarIconType;

  return (
    <Fragment>
      <Loader />
      <Taptop />
      <div
        className={`page-wrapper ${layout1} ${toggleIcon ? "sidebar-collapsed" : ""}`}
        sidebar-layout={sideBarIcon}
        id="pageWrapper"
      >
        <NotificationsProvider>
          <ChatProvider>
            <Header />
            <div className={`page-body-wrapper ${toggleIcon ? "sidebar-collapsed" : ""}`}>
              <Sidebar />
              {/* page-body: tek <Outlet> — eski TransitionGroup + CSSTransition
                  pattern'i sayfa geçişinde "fadeIn-enter-done" div'lerini
                  copy-paste duplicate ederek bırakıyordu (CSSTransition exit
                  class'ları SCSS'te tanımlı olmadığı için unmountOnExit
                  tetiklenmiyordu). Animasyon istenirse DESIGN.md §4 token'larıyla
                  CSS-only yapılır. */}
              <div className={`page-body ${toggleIcon ? "sidebar-collapsed" : ""}`}>
                <Outlet />
              </div>
            </div>
            <ChatLauncher />
          </ChatProvider>
        </NotificationsProvider>
      </div>
    </Fragment>
  );
};
export default AppLayout;
